export interface AddressModel {
  streetAddressLine1: string;
  streetAddressLine2: string;
  zipCode: string;
  city: string;
  state: string;
  country: string;
}

export const AddressModel = {
  formatAddress: (address: AddressModel | undefined): string | undefined => {
    if (!address) {
      return undefined;
    }
    const { streetAddressLine1, city } = address;
    const formattedAddress = [streetAddressLine1, city]
      .filter((value) => value)
      .join(', ')
      .trim();

    if (formattedAddress.length > 0) {
      return formattedAddress;
    }

    return undefined;
  },
};
